import React, { Fragment } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { Card } from 'reactstrap';
import TankTypeText from '~/components/tankTypeText/tankTypeText';
import TankStatusText from '~/components/tankStatusText/tankStatusText';

const TankSummaryCard = ({ className, type, status, volume, currentLot }) => {
  return (
    <Card className={cn(className, 'pa3')}>
      <h3 className="f4 mt0">Summary</h3>
      <h4 className="table-header mv0">Type</h4>
      <p>
        <TankTypeText capitalise type={type} />
      </p>
      <h4 className="table-header mv0">Current status</h4>
      <p>
        <TankStatusText capitalise status={status} />
      </p>
      {status === 'IN_USE' ? (
        <Fragment>
          <h4 className="table-header mv0">Lot in tank</h4>
          <p>{currentLot ? <Link to={`/lots/${currentLot.id}`}>{currentLot.reference}</Link> : 'Unknown'}</p>
        </Fragment>
      ) : null}
      <h4 className="table-header mv0">Total volume</h4>
      <p>{volume} L</p>
    </Card>
  );
};

export default TankSummaryCard;



// WEBPACK FOOTER //
// ./src/components/tankSummaryCard/tankSummaryCard.jsx